import { OfferKindEnum } from '../../../../services/exports/Constants';

const offers: Record<OfferKindEnum & { from_to: string }, any> = {
  [OfferKindEnum.PercentageOffByProducts]: {
    title: 'Spare {{percentageAmount}}% auf ausgewählte Artikel',
    description:
      'Spare {{percentageAmount}}% auf deine Bestellung, wenn du ausgewählte Artikel bestellst. Das Angebot ist gültig{{fromTo}}, bis das maximale Limit für Aktionen erreicht ist, je nachdem, was zuerst eintritt. Nicht mit anderen Aktionen kombinierbar.',
  },
  [OfferKindEnum.PercentageOffByMinSpendValue]: {
    title: '{{percentageAmount}}% Rabatt ab {{minSpendValue}}',
    description:
      'Spare {{percentageAmount}}% auf deine Bestellung. Das Angebot ist gültig{{fromTo}}, bis das maximale Limit für Aktionen erreicht ist, je nachdem, was zuerst eintritt. Nicht mit anderen Aktionen kombinierbar.',
  },
  [OfferKindEnum.AmountOffByProducts]: {
    title: 'Spare {{amount}} auf ausgewählte Artikel',
    description:
      'Spare {{amount}}, wenn du ausgewählte Artikel bestellst. Das Angebot ist gültig{{fromTo}}, bis das maximale Limit für Aktionen erreicht ist, je nachdem, was zuerst eintritt. Nicht mit anderen Aktionen kombinierbar.',
  },
  [OfferKindEnum.AmountOffByMinSpendValue]: {
    title: 'Spare {{amount}} ab {{minSpendValue}}',
    description:
      'Spare {{amount}} bei einem Bestellwert. Das Angebot ist gültig{{fromTo}}, bis das maximale Limit für Aktionen erreicht ist, je nachdem, was zuerst eintritt. Nicht mit anderen Aktionen kombinierbar.',
  },
  [OfferKindEnum.Bogo]: {
    title: '2 für den Preis von 1 kaufen!',
    description:
      'Kaufe einen Artikel und erhalte den zweiten Artikel kostenlos. Das Angebot ist gültig{{fromTo}}, bis das Aktionslimit erreicht ist, je nachdem, was zuerst eintritt. Nicht mit anderen Aktionen kombinierbar.',
  },
  [OfferKindEnum.BogoHalfPrice]: {
    title: 'Eins kaufen, eins zum halben Preis!',
    description:
      'Kaufe einen Artikel und erhalte den zweiten Artikel zum halben Preis. Das Angebot ist gültig{{fromTo}}, bis das Aktionslimit erreicht ist, je nachdem, was zuerst eintritt. Nicht mit anderen Aktionen kombinierbar.',
  },
  [OfferKindEnum.FreeItemByMinSpendValue]: {
    title: 'Kostenloser Artikel bei einem Bestellwert',
    description:
      'Erhalte einen kostenlosen Artikel, wenn du die Angebotsbedingungen erfüllst. Das Angebot ist gültig{{fromTo}}, bis das Aktionslimit erreicht ist, je nachdem, was zuerst eintritt. Nicht mit anderen Aktionen kombinierbar.',
    reward_items_description: 'Wähle den kostenlosen Artikel aus.',
  },
  [OfferKindEnum.FreeItemByProducts]: {
    title: 'Kostenloser Artikel bei deiner Bestellung',
    description:
      'Erhalte einen kostenlosen Artikel, wenn du die Angebotsbedingungen erfüllst. Das Angebot ist gültig{{fromTo}}, bis das Aktionslimit erreicht ist, je nachdem, was zuerst eintritt. Nicht mit anderen Aktionen kombinierbar.',
    qualifying_items_description:
      'Wähle die Artikel aus, die der Kunde bestellen muss, um den kostenlosen Artikel zu erhalten.',
    reward_items_description: 'Wähle den kostenlosen Artikel aus.',
  },
};

export default {
  offers,
  from_to: ' vom {{startsAt}} bis {{endsAt}} oder',
  qualifying_items_title: 'Qualifizierte Artikel',
  reward_items_title: 'Kostenlose Artikel',
  buttons: {
    add: 'Hinzufügen',
  },
};
